// Root getters
export default {
  isLogged: state => {
    return state.isLogged === 1
  },

  getRefreshToken: state => {
    return state.auth.refreshToken
  },

  getAccessToken: state => {
    return state.auth.accessToken
  },

  getSurveySlug: state => {
    return state.surveySlug
  },

  user: state => {
    return state.user
  },

  loadingModalActive: state => {
    return state.loadingModalActive
  },

  getErrors: state => {
    return state.errors
  }
}
